import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import theme from '../../theme';


export const OpenContentBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  color: theme.palette.grey.w400,
})

export const InputBox = styled(Box)(props => ({
  position: 'absolute',
  left: 0,
  width: '100%',
  padding: '10px 0',
  backgroundColor: 'rgba(244, 246, 250, 0.5)',
}))

// Mobile Tab
export const TabStack = styled(Stack)(({ theme }) => ({
  color: theme.palette.grey.w600,
  marginBottom: '4px'
}));

export const TabTitle = styled(Typography)(({ currenttab, color, type }) => {
  if (type === 'generationForm') {
    return {
      color: !currenttab ? color : theme.palette.grey.w600,
      fontWeight: !currenttab ? 600 : 300,
      marginRight: '14px',
      cursor: 'pointer'
    }
  }
  return {
    color: currenttab ? color : theme.palette.grey.w600,
    fontWeight: currenttab ? 600 : 300,
    cursor: 'pointer'
  }
});